import cryptoJS from 'crypto-js';
import {
    doTagCreditCardOfferAccepted,
    doTagCreditCardOfferNotAccepted,
    doTagNotResident,
    doTagRegisterSuccess,
    doTagRegisterSuccessButtonClick,
} from 'components/newAccountSteps/initialStep/tagging';
import { ONBOARDING_FLAG_WEB_NEW_REGISTER } from 'constants/featureFlagging';

export const useSaveRegisterRequests = (flags, userProfile, actions, onSavedCallback, wealthProduct = undefined) => {
    const checkboxEvent = () => {
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        if (userProfile.creditCardOffer_accepted) {
            doTagCreditCardOfferAccepted(userProfile, docNumberEncrypted);
        } else {
            doTagCreditCardOfferNotAccepted(userProfile, docNumberEncrypted);
        }
    };

    const handleSaveRequest = recaptcha => {
        const { docNumber } = userProfile;
        const isRegisterV2Active = flags.get(ONBOARDING_FLAG_WEB_NEW_REGISTER);
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        if (!userProfile.jointHolderForm) {
            actions.saveRegisterRequest({ ...userProfile, recaptcha }, wealthProduct, isRegisterV2Active, saved => {
                onSavedCallback(flags, saved, userProfile);
            });
        } else {
            actions.saveJointHolderRegisterRequest(userProfile, isRegisterV2Active, saved => {
                onSavedCallback(flags, saved, userProfile);
            });
        }
        doTagRegisterSuccess(userProfile, docNumberEncrypted);
        doTagRegisterSuccessButtonClick(userProfile, docNumberEncrypted);

        checkboxEvent();
    };

    const handleSaveNoResidentRequest = () => {
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        actions.saveNoResidentRequest(userProfile);
        doTagNotResident(userProfile, docNumberEncrypted);
        checkboxEvent();
    };

    return { handleSaveRequest, handleSaveNoResidentRequest };
};
